import React from "react";
import logoTransparent from "../../assets/images/logo/logo_transparent.png";
import { MenuLinesIcon } from "../../assets/icons";

const Navbar = ({ onMenuClick, currentPath, hideLogo = false }) => {

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-gray-200 lg:relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center lg:hidden">
            <button
              onClick={onMenuClick}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 transition-colors duration-200"
              aria-label="Toggle menu"
            >
              <MenuLinesIcon className="h-8 w-10" />
            </button>
          </div>
          {!hideLogo && (
            <div className="flex items-center justify-center flex-1 lg:hidden">
              <div className="flex items-center">
                <img
                  src={logoTransparent}
                  alt="Calbar Logo"
                  className="h-12 w-auto"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
